import React from "react";
import "./index.css";

const Pdfloader = (props) => {
  return (
    <div className="data-loader">
      <p>{props.loaderText}</p>
    </div>
  );
};

export default Pdfloader;



// WEBPACK FOOTER //
// ./src/new/Components/Data-loader/pdf-loader.jsx